import devConfig from './dev.config';
import prodConfig from './prod.config';
import stagingConfig from './staging.config';

let config = {
	MAPS_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
};

if (process.env.REACT_APP_NODE_ENV === 'production') {
	config = prodConfig;
} else if (process.env.REACT_APP_NODE_ENV === 'staging') {
	config = stagingConfig;
} else {
	config = devConfig;
}

if (process.env.REACT_APP_VERSION === '2') {
	config = {
		...config,
		apiPath: '/customer/app/v2',
	};
} else {
	config = {
		...config,
		apiPath: 'customer/app',
	};
}

export default config;
